import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import doc_yellow from "../../assets/doc_yellow.svg";
import setting_yellow from "../../assets/setting_yellow.svg";
import pin_yellow from "../../assets/pin_yellow.svg";
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";
import "./styleDomPersonal.css";

function HomeDomPersonal() {
  const navigate = useNavigate();
  const [strCPV, setStrCPV] = useState("");

  useEffect(() => {
    setStrCPV(localStorage.getItem("sCpv"));
  });

  const onTest = async () => {
    navigate("/DirDomPersonal", {
      state: { user: "userTest" },
    });
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Domicilio personal"
          name="HomeDomPersonal"
        />
        {/* <div className="containerRender"> */}
        <div className="containerInfo_P2">
          <div className="containerIdent_P2">
            <div className="txtOp_P2">Operación/Operation</div>
            <div className="txtVer_P2">Verificación de Domicilio Personal</div>
            <div className="txtCpv_P2">CPV/PVC</div>
            <div className='txtVer_P2'>{strCPV}</div>
            <div className="txtOp_P2">Remitente/Sender</div>
            <div className="txtVer_P2">Business Prey</div>
          </div>
          <div className="containerDoc_P2">
            <div className="txtReq_P2">Esta operación requiere:</div>
          </div>
          <div className="container_data_operation">
            <p>
              <img src={pin_yellow} align="left" className="imgFol_P2" />
              <div className="txtDocReq_P2">Ubicarse en Domicilio</div>
              <div className="txtIdenOf_P2">Debe encontrarse en su domicilio personal.</div>
            </p>
            <p>
              <img src={doc_yellow} align="left" className="imgFol_P2" />
              <div className="txtDocReq_P2">Comprobante de Domicilio</div>
              <div className="txtIdenOf_P2">Recibo de Agua, Luz o Teléfono.</div>
            </p>
            <p>
              <img src={setting_yellow} align="left" className="imgFol_P2" />
              <div className="txtDocReq_P2">Acceso a Ubicación</div>
              <div className="txtIdenOf_P2">Debe permitir el acceso en su navegador.</div>
            </p>



          </div>
        </div>
        {/* </div> */}

        <div className="footer">
          <div className="containerCont_P2">
            <button className="button_P2" onClick={onTest}>
              <span className="txtButton_P2">Confirmar</span>
            </button>
          </div>
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeDomPersonal;
